import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

 const PhoneNumberPopup = () => {
   const [showPopup, setShowPopup] = useState(true);
   const [formData, setFormData] = useState({
     name: '',
     phone: ''
   });
   const [errors, setErrors] = useState({
     name: '',
     phone: ''
   });
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [submitStatus, setSubmitStatus] = useState(null);
   const validateForm = () => {
     let isValid = true;
     const newErrors = { name: '', phone: '' };
     // Name validation
     if (!formData.name.trim()) {
       newErrors.name = 'Name is required';
       isValid = false;
     } else if (formData.name.trim().length < 2) {
       newErrors.name = 'Name must be at least 2 characters';
       isValid = false;
     }
     // Phone validation
     if (!formData.phone.trim()) {
       newErrors.phone = 'Phone number is required';
       isValid = false;
     } else if (!/^[0-9+\- ]+$/.test(formData.phone)) {
       newErrors.phone = 'Please enter a valid phone number';
       isValid = false;
     } else if (formData.phone.replace(/[^0-9]/g, '').length < 10) {
       newErrors.phone = 'Phone number must be at least 10 digits';
       isValid = false;
     }

     setErrors(newErrors);
     return isValid;
   };
   const handleChange = (e) => {
     const { name, value } = e.target;
     setFormData({
       ...formData,
       [name]: value
     });
  
     // Clear error when user types
     if (errors[name]) {
       setErrors({
         ...errors,
         [name]: ''
       });
     }
   };
   const handleSubmit = async (e) => {
     e.preventDefault();
  
     if (!validateForm()) return;
     setIsSubmitting(true);
     setSubmitStatus(null);
  
     try {
       const response = await axios({
         method: 'post',
         url: 'https://formsubmit.co/ajax/info@bodlagroup.com',
         data: {
           name: formData.name,
           phone: formData.phone,
           _subject: 'New Visitor Information',
           _template: 'box',
           _captcha: 'false'
         },
         headers: {
           'Content-Type': 'application/json',
           'Accept': 'application/json'
         },
         timeout: 15000
       });
       if (response.data.success === "true") {
         setSubmitStatus('success');
         setTimeout(() => setShowPopup(false), 2000);
       } else {
         setSubmitStatus('error');
       }
     } catch (error) {
       console.error('Submission error:', error);
       setSubmitStatus('error');
     } finally {
       setIsSubmitting(false);
     }
   };
   const handleClose = () => {
     setShowPopup(false);
   };
   if (!showPopup) return null;
   return (
     <div className="popup-overlay">
       <div className="popup-content">
         <button className="popup-close" onClick={handleClose}>×</button>
      
         {submitStatus !== 'success' ? (
           <>
             <h5>Welcome to Bodla Group</h5>
             <p>Please provide your details to continue:</p>
             <form onSubmit={handleSubmit}>
               <div className="form-group">
                 <label htmlFor="name">Your Name*</label>
                 <input
                   type="text"
                   id="name"
                   name="name"
                   value={formData.name}
                   onChange={handleChange}
                   placeholder="Enter your name"
                   className={errors.name ? 'is-invalid' : ''}
                 />
                 {errors.name && <div className="error-message">{errors.name}</div>}
               </div>
            
               <div className="form-group">
                 <label htmlFor="phone">Phone Number*</label>
                 <input
                   type="tel"
                   id="phone"
                   name="phone"
                   value={formData.phone}
                   onChange={handleChange}
                   placeholder="Enter your phone number"
                   className={errors.phone ? 'is-invalid' : ''}
                 />
                 {errors.phone && <div className="error-message">{errors.phone}</div>}
               </div>
            
               <button type="submit" disabled={isSubmitting}>
                 {isSubmitting ? 'Sending...' : 'Submit'}
               </button>
             </form>
           </>
         ) : (
           <div className="success-message">
             <p>Thank you for your information!</p>
           </div>
         )}
       </div>
     </div>
   );
 };
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PhoneNumberPopup />
    <App />
  </React.StrictMode>
);

reportWebVitals();